/* eslint-disable max-len */

export const getDescribe = (vm, orderId) => ({
  SEAT: {
    icon: '',
    tips: []
  },
  BCA: {
    icon: 'https://static.bakmigm.co.id/menu/bca.svg',
    tips: [
      {
        title: vm.$t('waiting.virtual.bankTransfer'),
        describe: [
          vm.$t('waiting.virtualDescribe.bca.bankTransfer.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.bankTransfer.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.bankTransfer.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.bankTransfer.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.bankTransfer.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.bankTransfer.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.bankTransfer.desc7', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.bankTransfer.desc8', { orderId, username: '{username}' }),
        ],
      },
      {
        title: vm.$t('waiting.virtual.mobileBanking'),
        describe: [
          vm.$t('waiting.virtualDescribe.bca.mobileBanking.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.mobileBanking.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.mobileBanking.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.mobileBanking.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.mobileBanking.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.mobileBanking.desc6', { orderId, username: '{username}' }),
        ],
      },
      {
        title: vm.$t('waiting.virtual.internetBankin'),
        describe: [
          vm.$t('waiting.virtualDescribe.bca.internetBankin.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.internetBankin.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.internetBankin.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.internetBankin.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.internetBankin.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.internetBankin.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bca.internetBankin.desc7', { orderId, username: '{username}' }),
        ],
      }
    ]
  },
  BNI: {
    icon: 'https://static.bakmigm.co.id/menu/bni.svg',
    tips: [
      {
        title: vm.$t('waiting.virtual.bankTransfer'),
        describe: [
          vm.$t('waiting.virtualDescribe.bni.bankTransfer.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.bankTransfer.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.bankTransfer.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.bankTransfer.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.bankTransfer.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.bankTransfer.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.bankTransfer.desc7', { orderId, username: '{username}' }),
        ]
      },
      {
        title: vm.$t('waiting.virtual.mobileBanking'),
        describe: [
          vm.$t('waiting.virtualDescribe.bni.mobileBanking.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.mobileBanking.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.mobileBanking.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.mobileBanking.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.mobileBanking.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.mobileBanking.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.mobileBanking.desc7', { orderId, username: '{username}' }),
        ],
      },
      {
        title: vm.$t('waiting.virtual.internetBankin'),
        describe: [
          vm.$t('waiting.virtualDescribe.bni.internetBankin.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.internetBankin.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.internetBankin.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.internetBankin.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.internetBankin.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.internetBankin.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bni.internetBankin.desc7', { orderId, username: '{username}' }),
        ]
      }
    ]
  },
  BRI: {
    icon: 'https://static.bakmigm.co.id/menu/bri.svg',
    tips: [
      {
        title: vm.$t('waiting.virtual.bankTransfer'),
        describe: [
          vm.$t('waiting.virtualDescribe.bri.bankTransfer.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.bankTransfer.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.bankTransfer.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.bankTransfer.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.bankTransfer.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.bankTransfer.desc6', { orderId, username: '{username}' }),
        ],
      },
      {
        title: vm.$t('waiting.virtual.mobileBanking'),
        describe: [
          vm.$t('waiting.virtualDescribe.bri.mobileBanking.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.mobileBanking.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.mobileBanking.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.mobileBanking.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.mobileBanking.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.mobileBanking.desc6', { orderId, username: '{username}' }),
        ],
      },
      {
        title: vm.$t('waiting.virtual.internetBankin'),
        describe: [
          vm.$t('waiting.virtualDescribe.bri.internetBankin.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.internetBankin.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.internetBankin.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.internetBankin.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.internetBankin.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.bri.internetBankin.desc6', { orderId, username: '{username}' }),
        ]
      }
    ]
  },
  Permata: {
    icon: 'https://static.bakmigm.co.id/menu/permata.svg',
    tips: [
      {
        title: vm.$t('waiting.virtual.bankTransfer'),
        describe: [
          vm.$t('waiting.virtualDescribe.permata.bankTransfer.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.bankTransfer.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.bankTransfer.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.bankTransfer.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.bankTransfer.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.bankTransfer.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.bankTransfer.desc7', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.bankTransfer.desc8', { orderId, username: '{username}' }),
        ]
      },
      {
        title: vm.$t('waiting.virtual.mobileBanking'),
        describe: [
          vm.$t('waiting.virtualDescribe.permata.mobileBanking.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.mobileBanking.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.mobileBanking.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.mobileBanking.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.mobileBanking.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.mobileBanking.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.mobileBanking.desc7', { orderId, username: '{username}' }),
        ],
      },
      {
        title: vm.$t('waiting.virtual.internetBankin'),
        describe: [
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc7', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc8', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.permata.internetBankin.desc9', { orderId, username: '{username}' }),
        ]
      }
    ]
  },
  Mandiri: {
    icon: 'https://static.bakmigm.co.id/menu/mandiri.svg',
    tips: [
      {
        title: vm.$t('waiting.virtual.bankTransfer'),
        describe: [
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc7', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc8', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.bankTransfer.desc9', { orderId, username: '{username}' }),
        ]
      },
      {
        title: vm.$t('waiting.virtual.mobileBanking'),
        describe: [
          vm.$t('waiting.virtualDescribe.mandiri.mobileBanking.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.mobileBanking.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.mobileBanking.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.mobileBanking.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.mobileBanking.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.mobileBanking.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.mobileBanking.desc7', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.mobileBanking.desc8', { orderId, username: '{username}' }),
        ],
      },
      {
        title: vm.$t('waiting.virtual.internetBankin'),
        describe: [
          vm.$t('waiting.virtualDescribe.mandiri.internetBankin.desc1', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.internetBankin.desc2', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.internetBankin.desc3', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.internetBankin.desc4', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.internetBankin.desc5', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.internetBankin.desc6', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.internetBankin.desc7', { orderId, username: '{username}' }),
          vm.$t('waiting.virtualDescribe.mandiri.internetBankin.desc8', { orderId, username: '{username}' }),
        ]
      }
    ]
  }
})
